module.exports = __webpack_public_path__ + "static/ray-f86686ea308770ecf4d6dee8f5121ef1.png";